import React from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Chip,
  Paper
} from '@mui/material';
import {
  Visibility as VisibilityIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  DesktopWindowsOutlined as DesktopWindowsOutlinedIcon,
  Web as WebIcon
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const ViewerSettings = ({ 
  viewerSettings, 
  setViewerSettings, 
  testResults,
  loading,
  testViewer,
  saveViewerSettings
}) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ p: 3 }}>
      {/* Hauptüberschrift */}
      <Typography variant="h4" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <VisibilityIcon color="primary" />
        {t('admin.serverManagement.viewerSettings')}
      </Typography>

      {/* Web Viewer */}
      <Paper sx={{ p: 3, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <WebIcon color="primary" />
          <Typography variant="h6">
            {t('admin.serverManagement.webViewer')}
          </Typography>
        </Box>
        
        <TextField
          fullWidth
          label={t('admin.serverManagement.baseUrl')}
          value={viewerSettings.web.base_url}
          onChange={(e) => setViewerSettings(prev => ({
            ...prev,
            web: { ...prev.web, base_url: e.target.value }
          }))}
          placeholder="http://localhost/jivexmobile/?user=guest&password=Guest&mode=load&studyInstanceUID=[studyInstanceUID]"
          InputLabelProps={{ shrink: true }}
          sx={{ mb: 2 }}
        />
        
        <TextField
          fullWidth
          label={t('admin.serverManagement.demoStudyUid')}
          value={viewerSettings.web.test_study_uid}
          onChange={(e) => setViewerSettings(prev => ({
            ...prev,
            web: { ...prev.web, test_study_uid: e.target.value }
          }))}
          placeholder="1.2.3.4.5.6.7.8.9"
          sx={{ mb: 2 }}
        />
        
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            onClick={() => testViewer('web')}
            disabled={loading}
            startIcon={<VisibilityIcon />}
            className="button"
          >
            {t('admin.serverManagement.testViewer')}
          </Button>
          <Button
            variant="contained"
            onClick={() => saveViewerSettings('web')}
            disabled={loading}
            className="button"
          >
            {t('admin.serverManagement.save')}
          </Button>
        </Box>
        
        {testResults.web && (
          <Chip
            icon={testResults.web.success ? <CheckCircleIcon /> : <ErrorIcon />}
            label={testResults.web.message}
            color={testResults.web.success ? 'success' : 'error'}
            sx={{ mt: 2 }}
          />
        )}
      </Paper>

      {/* Client Viewer */}
      <Paper sx={{ p: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <DesktopWindowsOutlinedIcon color="primary" />
          <Typography variant="h6">
            {t('admin.serverManagement.clientViewer')}
          </Typography>
        </Box>
        
        <TextField
          fullWidth
          label={t('admin.serverManagement.baseUrl')}
          value={viewerSettings.client.base_url}
          onChange={(e) => setViewerSettings(prev => ({
            ...prev,
            client: { ...prev.client, base_url: e.target.value }
          }))}
          placeholder="jivexrv:rv.startmode=load&rv.load.data.type=study&rv.load.data=[studyInstanceUID]"
          InputLabelProps={{ shrink: true }}
          sx={{ mb: 2 }}
        />
        
        <TextField
          fullWidth
          label={t('admin.serverManagement.demoStudyUid')}
          value={viewerSettings.client.test_study_uid}
          onChange={(e) => setViewerSettings(prev => ({
            ...prev,
            client: { ...prev.client, test_study_uid: e.target.value }
          }))}
          placeholder="1.2.3.4.5.6.7.8.9"
          sx={{ mb: 2 }}
        />
        
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Button
            variant="contained"
            onClick={() => testViewer('client')}
            disabled={loading}
            startIcon={<VisibilityIcon />}
            className="button"
          >
            {t('admin.serverManagement.testViewer')}
          </Button>
          <Button
            variant="contained"
            onClick={() => saveViewerSettings('client')}
            disabled={loading}
            className="button"
          >
            {t('admin.serverManagement.save')}
          </Button>
        </Box>
        
        {testResults.client && (
          <Chip
            icon={testResults.client.success ? <CheckCircleIcon /> : <ErrorIcon />}
            label={testResults.client.message}
            color={testResults.client.success ? 'success' : 'error'}
            sx={{ mt: 2 }}
          />
        )}
      </Paper>
    </Box>
  );
};

export default ViewerSettings;
